/** Name tag use on a mob (pure, DOM-free). A tag only works once it was renamed on an anvil. */
import { I } from '../itemIds';
import type { Stack } from '../types';

export const MAX_NAME_LENGTH = 50;

export interface Nameable { customName: string; persistent: boolean }

/** Name the mob after the tag; true when the tag was used (and should be consumed). */
export function applyNameTag(mob: Nameable, held: Stack): boolean {
  if (held.id !== I.NAME_TAG || !held.name) return false;
  mob.customName = held.name.slice(0, MAX_NAME_LENGTH);
  mob.persistent = true;
  return true;
}
